import { render } from "./site-search-locations.vue?vue&type=template&id=35d0f8b9"
import script from "./site-search-locations.vue?vue&type=script&lang=js"
export * from "./site-search-locations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__